<div class="error-container flex justify-center items-center m-10">
  <p-fieldset [legend]="title" class="text-red-700 font-bold rounded-r-xl">
    <i class="pi pi-exclamation-circle text-red-700"></i><p class="text-red-700">Message: {{ error()?.message }}</p>
    
    <p class="text-red-700">Status: {{ error()?.status }} {{ error()?.statusText }}</p>
     @if (error()?.stack){
    <p class="text-red-700" >Stack: {{ error()?.stack }}</p>
    }
    @if (error()?.name){
      <p class="text-red-700" >Name: {{ error()?.name }}</p>
      }
  </p-fieldset>
</div>
